import { lazy, Suspense } from 'react'
import { Link } from 'react-router'
import { cn } from '@/lib/utils'
import { useSebutanUnit } from '../store/sebutanUnit'
import { labelPeran, useSesi } from '../store/sesi'

interface UserBlockProps {
  className?: string
}

/**
 * The person: name with the role beneath in `label`. In a release build it opens Akun (spec
 * 2026-09-30 akun 4: the name in the header; Keluar and the display preferences are on Akun
 * since plan 9b). In development it opens a menu that switches the displayed role, so every
 * shell variant can be checked. The sync-state presets of wave 3 are gone: the engine drives
 * every state, and Sinkronisasi (section 16) shows them.
 */
export function UserBlock({ className }: UserBlockProps) {
  const sesi = useSesi((s) => s.asli)
  const sebutan = useSebutanUnit(sesi.parokiId)
  const teks = (
    <span className="flex min-w-0 flex-col items-start text-label leading-4">
      <span className="max-w-[12rem] truncate font-medium text-text">{sesi.nama}</span>
      <span className="max-w-[12rem] truncate text-muted">{labelPeran(sesi.peran, sebutan)}</span>
    </span>
  )
  if (!import.meta.env.DEV) {
    return (
      <Link
        to="/akun"
        className={cn('-mr-2 h-11 items-center gap-2 px-2 hover-band focus-settle', className)}
      >
        {teks}
      </Link>
    )
  }
  return (
    <Suspense fallback={teks}>
      <DevUserMenu className={className}>{teks}</DevUserMenu>
    </Suspense>
  )
}

// Development builds only: import.meta.env.DEV is folded to false in a release, so the menu
// and its dropdown code never reach the launch path.
const DevUserMenu = lazy(() => import('./UserBlockDev').then((m) => ({ default: m.DevUserMenu })))
